/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Setpointstartfrostfree3Inputs */



/**
* | output |
* | --- |
* | "External Temperature for Boiler Start" |
*
* @param {Ahu_History_Key_Setpointstartfrostfree3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_setpointstartfrostfree3 = /** @type {((inputs?: Ahu_History_Key_Setpointstartfrostfree3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Setpointstartfrostfree3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("External Temperature for Boiler Start")
	return /** @type {LocalizedString} */ ("Température ext. d'allumage des chaudières")
});
export { ahu_history_key_setpointstartfrostfree3 as "ahu_history_key_setpointStartFrostFree" }